var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationCircleIcon = function SvgLocationCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LocationCircleIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 47.097c12.15 0 22-10.06 22-22.468C46 12.22 36.15 2.161 24 2.161S2 12.221 2 24.629c0 12.409 9.85 22.468 22 22.468m0 2.043c13.255 0 24-10.974 24-24.511S37.255.119 24 .119 0 11.091 0 24.628s10.745 24.51 24 24.51",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LocationCircleIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.343 16.81A7.92 7.92 0 0 1 24 14.415c2.122 0 4.157.861 5.657 2.393A8.26 8.26 0 0 1 32 22.587c0 3.163-2.016 6.234-4.226 8.616A29.7 29.7 0 0 1 24 34.61a29.66 29.66 0 0 1-3.774-3.406C18.016 28.82 16 25.75 16 22.586a8.26 8.26 0 0 1 2.343-5.778m5.102 19.903.555-.85za.98.98 0 0 0 1.11 0l-.555-.85.555.85.003-.002.007-.005.023-.016.082-.058q.108-.075.302-.218a31.684 31.684 0 0 0 4.254-3.806C31.516 30.14 34 26.571 34 22.586c0-2.708-1.054-5.306-2.929-7.221A9.9 9.9 0 0 0 24 12.374a9.9 9.9 0 0 0-7.071 2.991A10.32 10.32 0 0 0 14 22.587c0 3.985 2.484 7.553 4.774 10.021a31.7 31.7 0 0 0 4.254 3.806 19 19 0 0 0 .384.276l.023.016.007.005zM22 22.587c0-1.128.895-2.043 2-2.043s2 .915 2 2.043-.895 2.042-2 2.042-2-.914-2-2.043m2-4.086c-2.21 0-4 1.83-4 4.085 0 2.257 1.79 4.086 4 4.086s4-1.83 4-4.085c0-2.257-1.79-4.086-4-4.086",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LocationCircleIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .118h48V49.14H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "LocationCircleIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12.374h24v24.51H12z"
  })))));
};
export default SvgLocationCircleIcon;